import { dashboardApiMiddleware } from "../api.middlewares";
import { PostHubspotData } from "./hubspot.interface";

export const postAddHubspotData = dashboardApiMiddleware<undefined, PostHubspotData>()({
  method: "post",
  endpoint: "/api/hubspot/proxy",
});
